module.exports = __webpack_public_path__ + "static/media/onda-fondo-rosa-rojo-aon-mobile.43eeffd9.png";